import { render, staticRenderFns } from "./InterestCards.vue?vue&type=template&id=2c70b91a&"
import script from "./InterestCards.vue?vue&type=script&lang=js&"
export * from "./InterestCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports